/**
 * Who created an appointment (PRD #1343). Orthogonal to `AppointmentStatus`:
 * a patient-created "pending hold" is a real, slot-blocking `SCHEDULED`
 * appointment that merely awaits practice confirmation. `PRACTICE` is the
 * default for every appointment the office books directly.
 */
export var AppointmentOrigin;
(function (AppointmentOrigin) {
    AppointmentOrigin["PRACTICE"] = "practice";
    AppointmentOrigin["PATIENT"] = "patient";
})(AppointmentOrigin || (AppointmentOrigin = {}));
//# sourceMappingURL=appointment-origin.enum.js.map